import React, { useEffect, useState } from "react";
import {
	Row,
	Col,
	Card,
	CardBody,
	Input,
	Label,
	Button,
	Form,
	Alert,
	FormGroup,
	Badge,
} from "reactstrap";
import { post, get } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TimeSlotDet from "./TimeSlotDet";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Trans } from "react-i18next";
import { SEARCH_TIMESLOT, ADD_TIMESLOT, SHOW_TIMESLOT, ADD_TIMESLOT_DET } from "helpers/api_endpoints";
import Select from "react-select";
import moment from "moment"

document.title = "Add Time Slot";

const AddTimeSlot = () => {
  const { id } = useParams();
  const navigate = useNavigate();
	const [partnerBranchId, setPartnerBranchId] = useState(0)
	const [loading, setLoading] = useState(false);
	const [errorMsg, setErrorMsg] = useState("");
	const [partnerBranches, setPartnerBranches] = useState([])

	// Form state
	const [name, setName] = useState("");
	const [slotDateFrom, setSlotDateFrom] = useState('');
	const [slotDateTo, setSlotDateTo] = useState('');
	const [daysOfWeek, setDaysOfWeek] = useState([]);
	const [expectedOrders, setExpectedOrders] = useState(0);
	const [status, setStatus] = useState(1);
	const [dets, setDets] = useState([{timeFrom:'', timeTo:'', prepareTimeFrom:null, prepareTimeTo:'', maxVolume:'0'}]);

	// Day options for recurring days
	const dayOptions = [
		{ value: 0, label: "Sunday" },
		{ value: 1, label: "Monday" },
		{ value: 2, label: "Tuesday" },
		{ value: 3, label: "Wednesday" },
		{ value: 4, label: "Thursday" },
		{ value: 5, label: "Friday" },
		{ value: 6, label: "Saturday" },
	];

  useEffect(() => {
      try {
        setErrorMsg('');
        if(id==undefined) return;
        get(`${SHOW_TIMESLOT}/${id}`).then(response => {
          const timeSlot = response.data;
          setName(timeSlot.name);
          setSlotDateFrom(timeSlot.slotDateFrom?.split('T')[0]);
          setSlotDateTo(timeSlot.slotDateTo?.split('T')[0]);
          setStatus(timeSlot.status);
          setDaysOfWeek(timeSlot.daysOfWeek);
          setDets(timeSlot.timeSlotDet);
          setLoading(false);
        })
      } catch (error) {
        console.log(error);
        setErrorMsg(error?.response?.data?.message || "Failed to load time slot data");
        setLoading(false);
      }

  }, [id]);

  // Helper function to convert time string to minutes since midnight
	const timeToMinutes = (timeStr) => {
		if (!timeStr) return 0;
		const [hours, minutes] = timeStr.split(":").map(Number);
		return hours * 60 + minutes;
	};

  const checkOverlapped = (dets) => {
    return false;
    let i = 0;
    let overlapped = false;
    console.log('dets', dets)
    if(dets.length == 1) return false;
    dets.forEach(det => {
      const {timeFrom, timeTo} = det;
      const cTimeFrom = timeToMinutes(timeFrom);
      const cTimeTo = timeToMinutes(timeTo);
      const loopDets = [...dets];
      loopDets.splice(i, 1);
      i++;
      loopDets.some(el => {
          const check1 = timeToMinutes(el.timeFrom);
          const check2 = timeToMinutes(el.timeTo);
          console.log('check1', check1, check2, cTimeFrom, cTimeTo)
          if((cTimeFrom >= check1 && cTimeFrom <= check2) || (cTimeTo >= check1 && cTimeTo <= check2))
          {
            console.log('overlapped')
            overlapped = true;
          }
      })
    })
    return overlapped;

  }

  const addTimeDet = () => {
    setErrorMsg("");
    // console.log('checkOverlapped(dets)', checkOverlapped(dets))
    const newDets = [...dets];
    newDets.push({timeFrom:'', timeTo:'', prepareTimeFrom:null, prepareTimeTo:'', maxVolume:'0'});
    setDets(newDets);
  }

  const removeTimeDet = (key) => {
    if(key == 0) return;
    const newDets = [...dets];
    newDets.splice(key, 1);
    setDets(newDets);
  }

	// Handle date range change
  const handleInput = (key='', type, val) => {
    console.log('handle', type, val);
    const newDets = [...dets];
    if(type == 'timeFrom')
      newDets[key].timeFrom = val;
    else if(type == 'timeTo')
      newDets[key].timeTo = val;
    else if(type == 'prepareTimeFrom')
      newDets[key].prepareTimeFrom = val;
    else if(type == 'prepareTimeTo')
      newDets[key].prepareTimeTo = val;
    else if(type == 'maxVolume')
      newDets[key].maxVolume = val;

    setDets(newDets);

  }
	// Validate form before submission
	const validateForm = () => {
    const today = moment().set({hour:0,minute:0,second:0,millisecond:0});
    const start = moment(slotDateFrom, 'YYYY-MM-DD');
    const end = moment(slotDateTo, 'YYYY-MM-DD');
    // console.log('today', today, start, end)
    if(checkOverlapped(dets))
    {
        setErrorMsg("Times overlap");
        return false;
    }

    // console.log('today', slotDateFrom, slotDateTo, daysOfWeek.length)
    if((slotDateFrom==null || slotDateTo==null || slotDateFrom=='' || slotDateTo=='') && daysOfWeek.length == 0)
    {
        setErrorMsg("Enter range or recurring days");
        return false;
    }
    if(start.diff(end)>=0 && daysOfWeek.length == 0)
    {
        setErrorMsg("Start date should not be after end date");
        return false;
    }
    
    // if(today.diff(start)>0 && daysOfWeek.length == 0)
    // {
    //     setErrorMsg("You must start from this today on");
    //     return false;
    // }
    return dets.some(det => {
      if (!det.timeFrom || !det.timeTo || !det.prepareTimeTo) {
        setErrorMsg("Start time, end time and cut off time are required");
        return false;
      }

      const startMinutes = timeToMinutes(det.timeFrom);
      const endMinutes = timeToMinutes(det.timeTo);
      const cutOffMinutes = timeToMinutes(det.prepareTimeTo);
      const orderStartMinutes = det.prepareTimeFrom ? timeToMinutes(det.prepareTimeFrom) : null;

      if (startMinutes >= endMinutes) {
        setErrorMsg("Start time must be earlier than end time");
        return false;
      }

      if (cutOffMinutes > endMinutes) {
        setErrorMsg("Cut off time must not be later than end time");
        return false;
      }

      if (det.prepareTimeFrom && orderStartMinutes >= cutOffMinutes) {
        setErrorMsg("Order start time must be before cut off time");
        return false;
      }

      // if (isNaN(expectedOrders) || expectedOrders < 0) {
      //   setErrorMsg("Expected orders must be a positive number");
      //   return false;
      // }

      if (daysOfWeek.length === 0 && slotDateFrom=='') {
        setErrorMsg("must have at least one recurring day");
        return false;
      }


      return true;
    })
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setErrorMsg("");

		if (!validateForm()) {
			setLoading(false);
			return;
		}

		try {
			const response = post(ADD_TIMESLOT, {name, slotDateFrom:slotDateFrom==''?null:slotDateFrom, slotDateTo:slotDateTo==''?null:slotDateTo, daysOfWeek})
        .then(async timeslot => {
          console.log('timeslot', timeslot)
          dets.forEach(async (det) => {
            console.log('post details', det)
            if(det.timeFrom != '')
            {
              post(ADD_TIMESLOT_DET, {timeslotId:timeslot.data.id, timeFrom: det.timeFrom, timeTo: det.timeTo
                , prepareTimeFrom: det.prepareTimeFrom, prepareTimeTo: det.prepareTimeTo, maxVolume: det.maxVolume})
                .catch(err => {
                    console.log(err)

                })
            }
          })
          if (timeslot.code === 201) {
            navigate(`/timeslots`, {
              state: { successMsg: response.message || "Time slot created successfully" },
            });
          }
        })
		} catch (error) {
			setErrorMsg(
				error?.response?.data?.message || "Failed to create time slot"
			);
			console.error("Error creating time slot:", error);
		} finally {
			setLoading(false); 
		}
	};

	return (
		<React.Fragment>
			<div className="page-content">
				<div className="container-fluid">
					<Breadcrumbs
						title="Time Slots"
						breadcrumbItem="Add Time Slot"
					/>

					<Form onSubmit={handleSubmit}>
						<Row>
							<Col xl={12}>
								<Card>
									<CardBody>
										{errorMsg && <Alert color="danger">{errorMsg}</Alert>}

										<Row>
											<FormGroup className="col-md-12">
												<Row>
												<div className=" col-md-4 mt-2">
													<Label className="form-label">
														<Trans>Name</Trans>
													</Label>
													<Input
														type="text"
														value={name}
														onChange={e => setName(e.target.value)}
														required
													/>
												</div>

												<div className=" col-md-4 mt-2">
													<Label className="form-label">
														<Trans>Date From</Trans>
													</Label>
													<Input
														type="Date"
														value={slotDateFrom}
														onChange={e => setSlotDateFrom(e.target.value)}
														
													/>
												</div>

												<div className=" col-md-4 mt-2">
													<Label className="form-label">
														<Trans>Date To</Trans>
													</Label>
													<Input
														type="Date"
														value={slotDateTo}
														onChange={e => setSlotDateTo(e.target.value)}
														
													/>
												</div>
												</Row>
											</FormGroup>

											<FormGroup className="col-md-12">
                        <Row>
												<div className=" col-md-6 mt-2">
												<Label>
													<Trans>Status</Trans>
												</Label>
												<Input
													type="select"
													value={status}
													onChange={e => setStatus(parseInt(e.target.value))}
													required
												>
													<option value={1}>Method 1</option>
													<option value={2}>Method 2</option>
													<option value={0}>Inactive</option>
												</Input>
												</div>
												<div className=" col-md-6 mt-2">
													<Label>
														<Trans>Recurring Days</Trans>
													</Label>
													<Select
														isMulti
														options={dayOptions}
														value={dayOptions.filter(option =>
															daysOfWeek.includes(option.value)
														)}
														onChange={selected =>
															setDaysOfWeek(selected.map(item => item.value))
														}
														className="basic-multi-select"
														classNamePrefix="select"
														
													/>
													</div>
                          </Row>
												</FormGroup>
										</Row>
                    <Row>
											<h3 className="mt-4">
												<Trans>Time Slot Details</Trans>
											</h3>
                      {dets.map((det,index) => (
                        <div  key={index}>
                          <TimeSlotDet setDet={setDets} handleInput={handleInput} akey={index} det={det} removeTimeDet={removeTimeDet} />
                        </div>

                      ))}
                      <br />

											<div className=" col-md-12 mt-2">
                        <div className="mt-4">
                          <Button type="button" color="primary" onClick={addTimeDet}>
                            Add
                          </Button>
                        </div>
                      </div>
                    </Row>

									</CardBody>
								</Card>
							</Col>
										<div className="mt-4">
											<Button type="submit" color="primary" >
												{loading ? "Processing..." : "Submit"}
											</Button>
										</div>
						</Row>
					</Form>
				</div>
			</div>
		</React.Fragment>
	)
};

export default AddTimeSlot;
